import { mapCollection } from '../../utils/collection.utils';
import { parseNumber } from '../../utils/number.utils';
import { IncidenceType } from '../incidence-type';

export class IncidenceTypeBuilder {
  static fromJson(json) {
    return (json)
      ? new IncidenceType(
        parseNumber(json.code),
        json.description,
        json.manuallyCreated,
        json.isFinished,
        json.isRecoverable,
        json.isScrapped,
        json.isPaused
      )
      : null;
  }

  static fromList(list) {
    return mapCollection(IncidenceTypeBuilder.fromJson, list);
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/incidence-type.builder.ts